import React from "react";

import config from "../../../config/config";

import "./ReferenceTables.scss";

const ReferenceTables2025 = () => {

  return (
    <>
      <h1>Reference Tables</h1>
      <section className="ref-tables-section">
        <ul>
          <li>
            <span className="ref-tables-volume">Volume 1 - CKD:</span>
            <ul>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2025&referenceTable=CKD_Ref_B_Prevalence_2025`}
                >
                  B. Prevalence
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2025&referenceTable=CKD_Ref_K_Expenditures_2025`}
                >
                  K. Expenditures
                </a>
              </li>
               <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2025&referenceTable=CKD_Ref_O_Drug_2025`}
                >
                  O. Drug
                </a>
              </li>
            </ul>
          </li>
          <li>
            <span className="ref-tables-volume">Volume 2 - ESRD:</span>
            <ul>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2025&referenceTable=ESRD_Ref_A_Incidence_2025`}
                >
                  A. Incidence
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2025&referenceTable=ESRD_Ref_B_Prevalence_2025`}
                >
                  B. Prevalence
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2025&referenceTable=ESRD_Ref_C_PatientChars_2025`}
                >
                  C. Patient Characteristics
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2025&referenceTable=ESRD_Ref_D_Modality_2025`}
                >
                  D. Treatment Modalities
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2025&referenceTable=ESRD_Ref_E_TransplantProcess_2025`}
                >
                  E. Transplantation: Process
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2025&referenceTable=ESRD_Ref_F_TransplantOutcomes_2025`}
                >
                  F. Transplantation: Outcomes
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2025&referenceTable=ESRD_Ref_G_Hospitalization_2025`}
                >
                  G. Morbidity and Hospitalization
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2025&referenceTable=ESRD_Ref_H_Mortality_2025`}
                >
                  H. Mortality and Causes of Death
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2025&referenceTable=ESRD_Ref_I_Survival_2025`}
                >
                  I. Patient Survival
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2025&referenceTable=ESRD_Ref_J_Providers_2025`}
                >
                  J. Provider Characteristics
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2025&referenceTable=ESRD_Ref_K_Costs_2025_all`}
                >
                  K. Expenditures for ESRD Patients (All)
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2025&referenceTable=ESRD_Ref_K_Costs_2025_DualEligible`}
                >
                  K.S1. Expenditures for ESRD Patients (Dual Eligible)
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2025&referenceTable=ESRD_Ref_K_Costs_2025_MedicareOnly`}
                >
                  K.S2. Expenditures for ESRD Patients (Medicare Only)
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2025&referenceTable=ESRD_Ref_L_VascularAccess_2025`}
                >
                  L. Vascular Access
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2025&referenceTable=ESRD_Ref_M_Census_2025`}
                >
                  M. Census Populations
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2025&referenceTable=ESRD_Ref_N_International_2025`}
                >
                  N. International Comparisons
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2025&referenceTable=ESRD_Ref_O_Drug_2025`}
                >
                  O. Drug
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2025&referenceTable=Reference_Table_Methods`}
                >
                  Analytical Methods
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </section>
    </>
  );
};

export default ReferenceTables2025;
